/* eslint-disable max-len */

// Flex Draft Status Block in Payment Card
export const FLEX_DRAFT_PAYMENT_STATUSES = {
  desktop: {
    Available: {
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconName: 'approved',
      linkLabel: 'Edit Settings',
      message: 'Your Flexible Drafting payment is scheduled.',
      operation: 'navigate',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Change_Additional_Information_Required: {
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconName: 'approved',
      linkLabel: 'Edit Settings',
      message: 'Your Flexible Drafting payment is scheduled.',
      operation: 'navigate',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Change_Request_Processing: {
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconName: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      operation: 'navigate',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Changed: {
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconName: 'approved',
      linkLabel: 'Edit Settings',
      message: 'Your Flexible Drafting payment is scheduled.',
      operation: 'navigate',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Enabled: {
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconName: 'approved',
      linkLabel: 'Edit Settings',
      message: 'Your Flexible Drafting payment is scheduled.',
      operation: 'navigate',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Rejected: {
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconName: 'approved',
      linkLabel: 'Edit Settings',
      message: 'Your Flexible Drafting payment is scheduled.',
      operation: 'navigate',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
  },
  mobile: {
    Available: {
      button: {
        label: 'Edit Settings',
        operationResponse: 'FlexDraftPreConfirmation',
      },
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconType: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Change_Additional_Information_Required: {
      button: {
        label: 'Edit Settings',
        operationResponse: 'FlexDraftPreConfirmation',
      },
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconType: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Change_Request_Processing: {
      button: null,
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconType: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Changed: {
      button: {
        label: 'Edit Settings',
        operationResponse: 'FlexDraftPreConfirmation',
      },
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconType: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Enabled: {
      button: {
        label: 'Edit Settings',
        operationResponse: 'FlexDraftPreConfirmation',
      },
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconType: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
    Rejected: {
      button: {
        label: 'Edit Settings',
        operationResponse: 'FlexDraftPreConfirmation',
      },
      header: 'Enrolled in Flexible Drafting',
      iconAlignSelf: 'flex-start',
      iconType: 'approved',
      message: 'Your Flexible Drafting payment is scheduled.',
      secondaryMessage: 'To cancel enrollment, call customer service at <a>{{customerServicePhoneNumber}}</a>.',
    },
  },
};

// Flex Draft Status Banner
export const FLEX_DRAFT_STATUS_UPDATES_DICTIONARY = {
  autopayEnrolled: {
    Enable_Additional_Information_Required: {
      None: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You are not eligible for Flexible Drafting. Your enrollment in automatic payments will remain active. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
      Request_Enable: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You may submit another request to enroll in Flexible Drafting. Your enrollment in automatic payments will remain active. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
    },
    Enable_Request_Processing: {
      text: '<b>Your Flexible Drafting Enrollment request is being processed.</b> Processing can take up to 15 business days. You will continue to be enrolled in automatic payments during this period. To cancel your Flexible Drafting enrollment request, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
      variant: 'pending',
    },
    Rejected: {
      None: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You are not eligible for Flexible Drafting. Your enrollment in automatic payments will remain active. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
      Request_Enable: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You may submit another request to enroll in Flexible Drafting. Your enrollment in automatic payments will remain active. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
    },
  },
  autopayNotEnrolled: {
    Change_Additional_Information_Required: {
      text: '<b>Your request to edit your Flexible Drafting settings was not approved.</b> You may try again by submitting a Flexible Drafting enrollment request with updated information. Your current Flexible Drafting settings will remain active. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
      variant: 'error',
    },
    Change_Request_Processing: {
      text: '<b>Your request to edit your Flexible Drafting settings is being processed.</b> Processing can take up to 15 business days. Your current Flexible Drafting settings will remain active during this period. To cancel your request, please contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
      variant: 'pending',
    },
    Deleted: {
      text: '<b>You’ve been unenrolled from Flexible Drafting.</b> Please be sure to make your payments by your monthly due date to avoid incurring late fees.',
      variant: 'success',
    },
    Enable_Additional_Information_Required: {
      None: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You are not eligible for Flexible Drafting. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
      Request_Enable: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You may submit another request to enroll in Flexible Drafting. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
    },
    Enable_Request_Processing: {
      text: '<b>Your Flexible Drafting Enrollment request is being processed.</b> Processing can take up to 15 business days. To cancel your Flexible Drafting enrollment request, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
      variant: 'pending',
    },
    Rejected: {
      None: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You are not eligible for Flexible Drafting. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
      Request_Change: {
        text: '<b>Your request to edit your Flexible Drafting settings was not approved.</b> You may try again by submitting a Flexible Drafting enrollment request with updated information. Your current Flexible Drafting settings will remain active. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
      Request_Enable: {
        text: '<b>Your Flexible Drafting enrollment request was not approved.</b> You may submit another request to enroll in Flexible Drafting. For more information, contact customer service at <a>{{customerServicePhoneNumber}}</a>.',
        variant: 'error',
      },
    },
  },
};
